import { gql, QueryHookOptions, useLazyQuery } from "@apollo/client";

import { EmailDocument } from "../types";
import { DOCUMENT_MATCH_RESULT_FIELDS } from "./fragments";
import { KontaxUserStatus } from "@/v1/types";
import { DocumentUploadSource } from "../schema.generated";

export interface EmailDocumentVariables {
  email?: string;
  options?: {
    id?: string;
    uploadSources?: DocumentUploadSource[];
    offset?: number;
    kontaxStatus?: KontaxUserStatus;
    manualMatchRequired?: boolean;
    dateFrom?: string;
    dateTo?: string;
    dateFilterField?: string;
    noDate?: boolean;
  };
}

export interface EmailDocumentResult {
  emailDocument: EmailDocument;
}

export const EMAIL_DOCUMENT_QUERY = gql`
  ${DOCUMENT_MATCH_RESULT_FIELDS}
  query emailDocument($email: String, $options: EmailDocumentOptionsInput) {
    emailDocument(email: $email, options: $options) {
      totalUnmatched
      id
      filename
      matchStatus
      name
      transactionId
      url
      amount
      currency
      date
      documentNumber
      iban
      createdAt
      userEmail
      manualMatchRequired
      transactionMatches {
        ...DocumentMatchResultFields
      }
    }
  }
`;

export const useEmailDocumentQuery = (
  options?: QueryHookOptions<EmailDocumentResult, EmailDocumentVariables>
) =>
  useLazyQuery<EmailDocumentResult, EmailDocumentVariables>(
    EMAIL_DOCUMENT_QUERY,
    options
  );
